import http from '@/utils/http';

/**
 * 获取分页查询提成分配明细-cyj
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/commission/page',
        method: 'post',
        data
    });
};

/**
 * 保存提成分配-cyj
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/commission/save',
        method: 'post',
        data
    });
};

/**
 * 批量保存提成分配-cyj
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/commission/batchSave',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/commission/importCommission',
        method: 'post',
        data
    });
};
